/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Group, TextField, TextAreaField, RadioField, SelectField, CheckboxField  } from '@insticator/insticator-ui'; // iui-material
import DropDownItem from 'material/autofilltext/dropdownitem/dropdownitem';
// styles
import injectSheet from 'react-jss';
import styles from 'material/autofilltext/autofilltext_styles';



/* ========== ~~~~~~~~~~ AUTO FILL TEXT ~~~~~~~~~~ ========== */
class AutoCompleteTextField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filteredList: [],
            searchTerm: '',
            active: false
        };
    }

    handleBlur = (e) => {
        this.props.handleBlur(e.target.value);
    }

    handleChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        let filteredItems = [];
        if(value.length > 0) {
            let initialItems = this.props.list.map(item => ({name: item.name, value: item.value.toLowerCase()}));
            filteredItems = initialItems.filter(item => item.value.indexOf(value.toLowerCase()) >= 0);
        }
        this.setState({filteredList: filteredItems, active: !!(filteredItems.length > 0), searchTerm: value});
        this.props.handleSelect(value);
    }

    handleSelect = item => {
        this.setState({active: false, searchTerm: ''});
        this.props.handleSelect(item.value);
    };

    renderItems = ()=> (
        this.state.filteredList.map((item, i)=>{
            return <DropDownItem handleSelect={this.handleSelect} searchTerm={this.state.searchTerm} name={item.name} value={item.value} itemSelected={this.state.filteredList[i] === item} key={i} index={i} item={item}  />
        })
    )

    // Returns the component specified by props.type, will need to constantly update imports with any new field types
    newField = () => {
      let ComponentType = TextField;
      switch (this.props.type) {
  			case 'text':
  			case 'color':
  			case 'date':
  			case 'datetime-local':
  			case 'email':
  			case 'password':
  			case 'month':
  			case 'number':
  			case 'range':
  			case 'search':
  			case 'tel':
  			case 'time':
  			case 'url':
  			case 'week':
          ComponentType = TextField;
          break;
  			case 'textarea':
          ComponentType = TextAreaField;
          break;
  			case 'select':
          ComponentType = SelectField;
          break;
  			case 'checkbox':
          ComponentType = CheckboxField;
          break;
  			case 'radio':
          ComponentType = RadioField;
          break;
  			default:
  				break;
  		}
    	return (
    			<ComponentType
            type={this.props.type}
            name={this.props.name}
            placeholder={this.props.placeholder}
            label={this.props.label}
            info={this.props.info}
            handleFocus={this.handleFocus}
            value={this.props.value}
            handleBlur={this.handleBlur}
            handleKeyDown={this.handleKeyDown}
            handleChange={this.handleChange}
            valid={this.props.valid}
            required={this.props.required}
    			/>
    	);
    };

    render() {
        return (
            <Group name={`menuItems ${this.props.classes.autotextfill}`}  >
                    {this.newField()}
                <Group name={`items active-${this.state.active}`}>
                    {this.renderItems()}
                </Group>
            </Group>
        );
    }

};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AutoCompleteTextField);
